import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import { useMyCarsSiteProperties } from './useMyCarsSiteProperties';
import { calculateFooterCTAVisibility } from '../utilities/footerCTAs';
import {
	selectIsGridLayout,
	getShouldShowCompareOverImage
} from '../utilities/layout';

/**
 * Custom hook to manage footer CTA visibility logic with memoization
 * @returns {Object} Footer CTA configuration and helper functions
 */
export const useFooterCTAs = () => {
	const {
		displaySaveIconOn,
		removeFooterLinks,
		enableCompare,
		enableCompareOverImage
	} = usePrefs();
	const { enableMyCars } = useMyCarsSiteProperties();
	const isGridLayout = useSelector((state) => selectIsGridLayout(state));
	const { isSmallScreen } = useSelector((state) => state.layout);

	const shouldShowCompareOverImage = getShouldShowCompareOverImage(
		enableCompare,
		enableCompareOverImage,
		isGridLayout,
		isSmallScreen
	);

	return useMemo(
		() =>
			calculateFooterCTAVisibility(
				removeFooterLinks,
				displaySaveIconOn,
				enableMyCars,
				enableCompare,
				shouldShowCompareOverImage
			),
		[
			removeFooterLinks,
			displaySaveIconOn,
			enableMyCars,
			enableCompare,
			shouldShowCompareOverImage
		]
	);
};
